// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__3VIlt","searchIcon":"SearchBar_searchIcon__K2IDo","searchInput":"SearchBar_searchInput__1lEE1"};